import { c as _c } from "react/compiler-runtime";
import { cn } from "cn";
import type * as React from "react";
interface TextareaProps extends React.ComponentProps<"textarea"> {}

/** Multi-line text input that grows with its content. */
function Textarea(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex field-sizing-content min-h-16 w-full min-w-0 rounded-sm", "border border-border bg-card text-foreground body-md", "px-3 py-2", "placeholder:text-muted-foreground", "transition-[color,box-shadow,border-color] outline-none", "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-(--notification-destructive-fg)", "aria-invalid:focus-visible:ring-destructive/20 dark:aria-invalid:focus-visible:ring-destructive/40", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <textarea data-slot="textarea" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { Textarea, type TextareaProps };